import React, { useEffect, useState, useCallback, useRef } from 'react';
import { StyleSheet, View, FlatList, TouchableOpacity, TouchableWithoutFeedback, Keyboard, Pressable } from 'react-native';
import { TextInput, Text, Button } from 'react-native-paper';
import { useNavigation, useRoute, useFocusEffect } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import CustomModal from './CustomModal';
import CustomAlert from './CustomAlert';
import theme from './../../lib/theme.js';
import { apiFetch } from '../modules/api';
import { useGeolocation } from "./../providers/GeoLocationProvider";


const ListadoTiendas = () => {
  const defaultTitle = "Atención";
  const navigation = useNavigation();
  const { positionRef, error } = useGeolocation();
  const [determinantes, setDeterminantes] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [cameraaPermission, setCameraPermission] = useState(false);
  const [galleryPermission, setGalleryPermission] = useState(null);
  const [loadingStore, setLoadingStore] = useState(null);

  const [alertText, setAlertText] = useState("");
  const [alertTitle, setAlertTitle] = useState(defaultTitle);
  const [onAcceptAlert, setOnAcceptAlert] = useState(null);
  const [onCancelAlert, setOnCancelAlert] = useState(null);

  const lastPosition = useRef(null);


  const defaultDataForGeo = {
    operador: "",
    determinante: "",
    determinante_detalle: "",
    coordenadas: "",
    tiendaenturno: "",
    por_lotes: "",
    nombre: ""
  }
  const [dataForGeo, setDataForGeo] = useState(defaultDataForGeo);

  useEffect(() => {
    navigation.addListener('beforeRemove', (e) => {
      e.preventDefault();
      setAlertVisible(true);
      setAlertTitle("Cerrar sesión");
      setAlertText("Estás a punto de cerrar sesión\n¿Deseas continuar?");
      setOnAcceptAlert(() => () => { window.location.reload() });
      setOnCancelAlert(() => () => resetAlert());
    });
  }, [navigation]);


  const permisionFunction = async () => {
    // here is how you can get the camera permission
    setCameraPermission(true);
    setGalleryPermission(true);
    return true;
  };

  gPantalla = useRoute();

  async function fetchData() {
    setIsLoading(true);
    permisionFunction();
    setDeterminantes({});
    gPantalla = "";
    const datos = '{"empresa" : "' + gEmpresa + '","usuario" : "' + gUsuario + '"}'
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos,
      credentials: "include"
    }

    const response = await apiFetch(gApiPath + "/api/determinanteVisitar", requestOptions);
    const json = await response.json();
    var orden = 0;
    var tiendaTurno = false;
    for (var key in json.datos) {
      if (json.datos[key]["forzar_orden_visitas"] == 1) {
        orden = 1;
        break;
      }
    }

    for (var key in json.datos) {
      if (orden == 1) {
        json.datos[key]["tiendaenturno"] = 0;
        if (json.datos[key]["abierta"] == 1) {
          json.datos[key]["tiendaenturno"] = 1;
          tiendaTurno = true;
        }

        if (json.datos[key]["abierta"] == 0 && !tiendaTurno) {
          json.datos[key]["tiendaenturno"] = 1;
          tiendaTurno = true;
        }


        if (json.datos[key]["abierta"] == 2) {
          json.datos[key]["tiendaenturno"] = 1;
        }

      } else {
        json.datos[key]["tiendaenturno"] = 1;
      }
    }
    setDeterminantes(json.datos);
    setIsLoading(false);
  }

  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, [])
  );

  useEffect(() => {
    if (dataForGeo.determinante !== "" && determinantes.length > 0) {
      const item = determinantes.filter((deter) => deter.determinante === dataForGeo.determinante)[0];
      irTienda(item.operador, item.determinante, item.nombre + " - " + item.ciudad, item.coordenadas_geograficas, item.tiendaenturno, item.por_lotes, item.nombre);
      setDataForGeo(defaultDataForGeo);
    }
  }, [determinantes])

  const irTienda = (operador, determinante, determinante_detalle, coordenadas, tiendaenturno, por_lotes, nombre) => {

    const dataForGeoTMP = {
      operador,
      determinante,
      determinante_detalle,
      coordenadas,
      tiendaenturno,
      por_lotes,
      nombre
    }

    if (tiendaenturno == 1) {
      gOperador = operador;
      gDeterminante = determinante;
      gNombre = nombre;
      gDeterminanteDetalle = determinante_detalle.toUpperCase();

      if (coordenadas === "") {
        setDataForGeo(dataForGeoTMP);
        setModalVisible(true);
      } else {
        validarDistancia(por_lotes, dataForGeoTMP);
      }
    } else {
      gMsg = "Capture todos los datos de productos de la tienda anterior";
      showAlert();

    }
  }

  const resetAlert = () => {
    setAlertVisible(false);
    setAlertTitle(null);
    setAlertText(null);
    setOnAcceptAlert(null);
  }


  async function validarGpsEncendido() {

    let { status } = await Location.requestForegroundPermissionsAsync();

    if (status !== 'granted') {
      setErrorMsg('Permission to access location was denied');
      gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
      showAlert();
      navigation.navigate("Acceso");
      return;
    }
  }

  async function validarDistancia(por_lotes, dataForGeoTMP = defaultDataForGeo, reintentos = 0) {
    try {
      setAlertTitle("Abriendo tienda");
      setAlertVisible(true);
      setAlertText("Obteniendo ubicación, por favor espere..." + reintentos > 0 ?? ' Reintento: '+ reintentos);
      if(!positionRef.current?.longitude){
          if (reintentos === 3) {
            setAlertText("Ocurrió un problema obteniendo la ubicación del dispositivo, favor de desactivar el WIFI o moverse a un lugar con mejor señal.");
            setOnAcceptAlert(() => () => resetAlert());
            return;
          }
          setTimeout(() => {
            reintentos++;
            validarDistancia(por_lotes, dataForGeoTMP, reintentos);
          }, 5000);
          return;
      }
      let geoloc = 'Waiting..';
      gGeo = positionRef.current;

      setAlertText("Registrando visita...");
      const altitude = gGeo.altitude
      const latitude = gGeo.latitude
      const longitude = gGeo.longitude
      const datos = '{"operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '","latitude" : "' + latitude + '","longitude" : "' + longitude + '","altitude" : "' + altitude + '"}';

      var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: datos
      };

      const response = await apiFetch(gApiPath + "/api/calcularDistancia", requestOptions);
      const json = await response.json();
      setAlertVisible(false);
      if (json.estatus == "bien") {
        global.gTipoCapInv = por_lotes === "1" || por_lotes === "true" || por_lotes === true ? true : false;
        registarEntrada(gGeo);
      } else if (json.estatus == "error" && json.mensaje.startsWith("Error calculando distan")) {
        setDataForGeo(dataForGeoTMP);
        setModalVisible(true);
      } else {
        gMsg = gOperador.toUpperCase() + " - " + gDeterminante + ": " + json.mensaje;
        showAlert();
      }

    } catch (e) {
      console.log("catch??", e);
      if (reintentos === 3) {
        setAlertText("Ocurrió un problema obteniendo la ubicación del dispositivo, favor de desactivar el WIFI o moverse a un lugar con mejor señal.");
        setOnAcceptAlert(() => () => resetAlert());
        return;
      }
      setAlertText("Obteniendo ubicación, por favor espere...");
      setTimeout(() => {
        reintentos++;
        validarDistancia(por_lotes, dataForGeoTMP, reintentos);
      }, 5000);
      //validarGpsEncendido();
      console.log("error obteniendo ubicación", e)
    }

  }

  async function registarEntrada(gGeoParam) {

    /*let { status } = await Location.requestForegroundPermissionsAsync();
    if (status !== 'granted') {
      setErrorMsg('Permission to access location was denied');
      navigation.navigate("Acceso");
      return;
    }*/
    try {
      var altitude = gGeoParam.altitude;
      var latitude = gGeoParam.latitude;
      var longitude = gGeoParam.longitude;
      var datos = '{"usuario" : "' + gUsuario + '","operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '","latitude" : "' + latitude + '","longitude" : "' + longitude + '","altitude" : "' + altitude + '"}'
      var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: datos
      };

      const response = await apiFetch(gApiPath + "/api/abrirTienda", requestOptions);
      const json = await response.json();
      if (json.estatus == "error") {
        setAlertTitle("Atención");
        gMsg = json.mensaje;
        showAlert();
        navigation.goBack();
      } else {
        navigation.navigate('Tienda');
      }
    } catch {
      validarGpsEncendido();
    }

  }

  function showAlert() {
    setAlertTitle("Atención");
    setOnAcceptAlert(() => () => resetAlert());
    setAlertText(gMsg);
    setAlertVisible(true);
  }

  const ModalContent = (props) => {
    const { modalVisible, setModalVisible, setPreventClose } = props;
    const emptyForm = {
      contrasena: ""
    };
    const [state, setState] = useState(emptyForm);
    const [isLoadingGeo, setIsLoadingGeo] = useState(false);
    const [canContinueForm, setCanContinueForm] = useState(true);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
      if (state.contrasena.trim() !== "") {
        setCanContinueForm(false);
      } else {
        setCanContinueForm(true);
      }
    }, [state])

    const handleChangetest = (name, value) => {
      setState({ ...state, [name]: value })
    }

    const cancelForm = (resetDataForGeo = false) => {
      if (!isLoadingGeo) {
        setModalVisible(false);
        setState(emptyForm);
        setSuccess(false);
        if (resetDataForGeo) {
          setDataForGeo(defaultDataForGeo);
        }
      }
    }

    async function guardarCoordenadas(reintentos = 0) {
      if (canContinueForm || isLoadingGeo) {
        return true;
      }
      Keyboard.dismiss;
      setIsLoadingGeo(true);
      setPreventClose(true);
      if(!positionRef.current?.longitude){
          if (reintentos === 3) {
            setAlertText("Ocurrió un problema obteniendo la ubicación del dispositivo, favor de desactivar el WIFI o moverse a un lugar con mejor señal.");
            setOnAcceptAlert(() => () => resetAlert());
            return;
          }
          setTimeout(() => {
            reintentos++;
            guardarCoordenadas(reintentos);
          }, 5000);
          return;
      }
      let geoloc = 'Waiting..';
      gGeo = positionRef.current;
      const altitude = gGeo.altitude
      const latitude = gGeo.latitude
      const longitude = gGeo.longitude

      const datos = '{"contrasena" : "' + state.contrasena + '","operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '","latitude" : "' + latitude + '","longitude" : "' + longitude + '","altitude" : "' + altitude + '"}'

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: datos
      };

      const response = await apiFetch(gApiPath + "/api/guardarCoordenadas", requestOptions);
      const json = await response.json();
      
      
      if (json.estatus == "bien") {
        setTimeout(() => {
          setSuccess(true);
          setIsLoadingGeo(false);
          setPreventClose(false);
          cancelForm();
          fetchData();
        }, 2000);
      } else if (json.mensaje === "Contraseña incorrecta") {
        gMsg = json.mensaje;
        showAlert();
        setIsLoadingGeo(false);
        setPreventClose(false);
      } else {
        gMsg = json.mensaje;
        cancelForm(true);
        showAlert();
        setIsLoadingGeo(false);
        setPreventClose(false);
      }
      setState(emptyForm);
    }
    const styles = StyleSheet.create({
      textStyle: {
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      modalText: {
        marginBottom: 15,
        textAlign: 'center',
      },
    });

    return (
      <View>
        {success ? (
          <TouchableWithoutFeedback>
            <Button mode="contained" style={{ marginTop: 20, backgroundColor: theme.colors.success }}>
              Se registró correctamente
            </Button>
          </TouchableWithoutFeedback>
        ) : (
          <View>
            <Text style={styles.modalText}>La tienda seleccionada requiere capturar sus coordenadas, ingrese la contraseña para continuar</Text>
            <TextInput
              disabled={success}
              secureTextEntry={true}
              label={"Contraseña"}
              value={state.contrasena}
              onChangeText={(value) => handleChangetest("contrasena", value)}
            />
            <Button onPress={() => guardarCoordenadas()} disabled={canContinueForm} loading={isLoadingGeo} mode="contained" style={{ marginTop: 20, marginBottom: 10 }}>
              {!isLoadingGeo ? 'Registrar coordenadas' : ''}
            </Button>
            <Pressable>
              <Button onPress={() => cancelForm(true)} disabled={isLoadingGeo} mode="contained" style={isLoadingGeo ? {} : theme.buttons.error}>
                Cancelar
              </Button>
            </Pressable>
          </View>
        )}
      </View>
    );
  }

  return (
    <View style={{ flex: 1, width: '100%', alignItems: 'center' }}>
      <Fondo />
      <CustomAlert alertVisible={alertVisible} setAlertVisible={setAlertVisible} text={alertText} title={alertTitle} onAccept={onAcceptAlert} onCancel={onCancelAlert} />
      <CustomModal modalVisible={modalVisible} setModalVisible={setModalVisible} Content={ModalContent} />
      {!isLoading ? (
        <FlatList style={{ flex: 1, aignItems: 'center', width: '100%' }}
          data={determinantes}
          renderItem={({ item }) => (
            <View style={{ flex: 1, aignItems: 'center', width: '100%', shadowOpacity: 0, elevation: 0 }}>
              {item.abierta == 2 ? (
                <TouchableOpacity style={{ ...theme.cards, backgroundColor: theme.colors.success }} onPress={() => irTienda(item.operador, item.determinante, item.nombre + " - " + item.ciudad, item.coordenadas_geograficas, item.tiendaenturno, item.por_lotes, item.nombre)}>
                  <Text style={theme.storeCardTitle} >{item.operador.toUpperCase()} - {item.determinante.toUpperCase()} - {item.nombre.toUpperCase()} </Text>
                  <Text style={theme.storeCardTitle} >{item.formato.toUpperCase()} </Text>
                  <Text style={theme.storeCardTitle} >{item.ciudad.toUpperCase()}</Text>
                </TouchableOpacity>
              ) : item.abierta == 1 ? (
                <TouchableOpacity style={{ ...theme.cards, backgroundColor: theme.colors.warning }} onPress={() => irTienda(item.operador, item.determinante, item.nombre + " - " + item.ciudad, item.coordenadas_geograficas, item.tiendaenturno, item.por_lotes, item.nombre)}>
                  <Text style={theme.storeCardTitle}>{item.operador.toUpperCase()} - {item.determinante.toUpperCase()} - {item.nombre.toUpperCase()} </Text>
                  <Text style={theme.storeCardTitle} >{item.formato.toUpperCase()} </Text>
                  <Text style={theme.storeCardTitle} >{item.ciudad.toUpperCase()}</Text>
                </TouchableOpacity>) : (
                <TouchableOpacity style={{ ...theme.cards, backgroundColor: theme.colors.danger }} onPress={() => irTienda(item.operador, item.determinante, item.nombre + " - " + item.ciudad, item.coordenadas_geograficas, item.tiendaenturno, item.por_lotes, item.nombre)}>
                  <Text style={theme.storeCardTitle} >{item.operador.toUpperCase()} - {item.determinante.toUpperCase()} - {item.nombre.toUpperCase()} </Text>
                  <Text style={theme.storeCardText} >{item.formato.toUpperCase()} </Text>
                  <Text style={theme.storeCardText} >{item.ciudad.toUpperCase()}</Text>
                </TouchableOpacity>)}
            </View>
          )}
          keyExtractor={item => item.id}
        />
      ) : (
        <Text>Cargando...</Text>
      )}
    </View>
  );
}

export default ListadoTiendas

const styles = StyleSheet.create({

  titulo: {
    fontSize: 25,
    color: "white",
    fontWeight: 'bold',
    marginTop: 10,
  }, text: {
    fontSize: 15,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  titulo1: {
    fontSize: 30,
    color: "white",
    fontWeight: 'bold',
    marginTop: 40,
  },

  titulo2: {
    marginTop: 20,
    fontSize: 35,
    color: "black",
    fontWeight: 'bold'
  },
  container2: {
    flex: 1,
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },

  containerSkeleton: {
    padding: 10,
  }

});



